import { z } from 'zod';

export const rejectShouttSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(3, 'Give a short reason (3+ characters)')
    .max(300, 'Keep the reason under 300 characters'),
});

export type RejectShouttForm = z.infer<typeof rejectShouttSchema>;

export const resolveReportSchema = z.object({
  note: z.string().trim().max(500, 'Keep the note under 500 characters').optional(),
});

export type ResolveReportForm = z.infer<typeof resolveReportSchema>;
